import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { noop } from 'rxjs';

import { NotificationCard } from '../../../../../../common/models/main';
import { ApiService } from '../../../../../../common/services/api.service';
import { EventService } from '../../../../../../common/services/event.service';
import { Helper } from '../../../core/helper';

@Component({
  selector: 'app-notification-card[notification]',
  templateUrl: './notification-card.component.html',
  styleUrls: ['./notification-card.component.scss'],
})
export class NotificationCardComponent implements OnInit {
  @Input() notification!: NotificationCard;
  @Output() notificationChange = new EventEmitter();
  isMessage: boolean = false;
  avatarType: 'image' | 'initials' | 'icon' | 'iconInitials' = 'icon';
  avatarStyle: 'notification' | 'notification-warn' = 'notification';

  data: { title: string, avatarData: string, message: string, recordUrl: string, bodyUrl: string, queryParams: Record<string, any>, messageTitle: string, chatTitle?: string} = { title: '', avatarData: '', message: '', recordUrl: '', bodyUrl: '', queryParams: {}, messageTitle: '' };

  constructor(private api: ApiService, private eventService: EventService, private translate: TranslateService, private router: Router) { }

  ngOnInit() {
    this.startCard(this.notification);
  }

  startCard(notification: NotificationCard) {
    if (notification.params.recordId) {
      const notificationCardId = Helper.getShortId(notification.params.recordId);
      this.data.title = notification.params.recordAlias ? `${notificationCardId} | ${notification.params.recordAlias}` : notificationCardId;
    }
    this.data.message = notification.text;
    this.avatarStyle = 'notification';
    if (notification.params.recordId) this.data.recordUrl = `/record-detail/${notification.params.recordId}/canvas`;
    switch (notification.name) {
      case 'recordInviteCollaborator':
        this.data.avatarData = 'invite';
        this.data.bodyUrl = `/record-detail/${notification.params.recordId}/canvas`;
        break;
      case 'recordUploadNewDocumentVersion':
        this.data.avatarData = 'folder';
        this.data.bodyUrl = `/record-detail/${notification.params.recordId}/documents`;
        this.data.queryParams = {
          documentId: notification.params.documentId,
          versionId: notification.params.versionId,
        };
        break;
      case 'recordUpdateDocument':
        this.data.avatarData = 'folder';
        this.data.bodyUrl = `/record-detail/${notification.params.recordId}/documents`;
        this.data.queryParams = {
          documentId: notification.params.documentId,
          versionId: notification.params.versionId,
        };
        break;
      case 'recordUploadNewDocument':
        this.data.avatarData = 'folder';
        this.data.bodyUrl = `/record-detail/${notification.params.recordId}/documents`;
        this.data.queryParams = {
          documentId: notification.params.documentId,
          versionId: notification.params.versionId,
        };
        break;
      case 'recordUpdateActor':
        this.data.avatarData = 'user';
        this.data.bodyUrl = `/record-detail/${notification.params.recordId}/actors/${notification.params.actorSubtype}/${notification.params.actorId}/data`;
        break;
      case 'recordUpdateDetails':
        this.data.avatarData = 'file-text';
        this.data.bodyUrl = `/record-detail/${notification.params.recordId}/canvas`;
        break;
      case 'recordUpdatePlace':
        this.data.avatarData = 'location-pin';
        this.data.bodyUrl = `/record-detail/${notification.params.recordId}/places/${notification.params.placeSubtype}/${notification.params.placeId}/data`;
        break;
      case 'chatInvite':
        this.data.avatarData = 'message-new';
        if (notification.params.recordId && notification.params.chatId) this.data.bodyUrl = `/record-detail/${notification.params.recordId}/messages/${notification.params.chatId}`;
        this.data.chatTitle = notification.params.chatTitle;
        break;
      case 'chatNewMessage':
        this.data.avatarData = 'messages';
        if (notification.params.chatId) this.data.bodyUrl = `/messages/${notification.params.chatId}`;
        this.isMessage = true;
        if (notification.params.userName) {
          if (notification.params.organizationName) this.data.messageTitle = notification.params.userName + ' | ' + notification.params.organizationName;
          else this.data.messageTitle = notification.params.userName;
        } else if (notification.params.organizationName) {
          this.data.messageTitle = notification.params.organizationName;
        } else {
          this.data.messageTitle = notification.params.userMail;
        }
        break;
      case 'chatExclude':
        this.data.avatarData = 'messages-out';
        this.data.bodyUrl = '/messages';
        this.data.chatTitle = notification.params.chatTitle;
        this.avatarStyle = 'notification-warn';
        break;
      case 'newOrganizationMember':
        this.avatarType = 'iconInitials';
        if (notification.params.userName) this.data.avatarData = notification.params.userName;
        this.data.bodyUrl = '/profile/organization';
        break;
    }
  }

  markAsRead(notification: NotificationCard) {
    notification.isRead = !notification.isRead;
    this.notificationChange.emit(notification);
    this.api.markNotificationAsRead(notification.id, notification.isRead).subscribe(noop);
  }

  async navigate(configuration: Record<string, any>, notification: NotificationCard, url: string) {
    if (!notification.isRead) this.markAsRead(notification);
    if (url) await this.router.navigate([url], { queryParams: configuration.queryParams });
  }
}
